import {
  Grid,
  Hidden,
  List as MuiList,
  ListItemButton as MuiListItemButton,
  ListItemText as MuiListItemText,
} from "@mui/material";
import useAuth from "hooks/useAuth";
import * as React from "react";
import { Link as RouterLink } from "react-router-dom";
import styled from "styled-components/macro";

const Wrapper = styled.div`
  padding: ${(props) => props.theme.spacing(1.25, 3)};
  position: relative;
`;

const List = styled(MuiList)`
  margin: 0;
  padding: 0;
`;

const ListItemButton = styled(MuiListItemButton)`
  display: inline-block;
  width: auto;
  min-height: 0;
  padding-top: ${(props) => props.theme.spacing(0.5)};
  padding-bottom: ${(props) => props.theme.spacing(0.5)};
  padding-left: ${(props) => props.theme.spacing(2)};
  padding-right: ${(props) => props.theme.spacing(2)};

  &,
  &:hover,
  &:active {
    color: ${(props) => props.theme.palette.footer.link};
  }
`;

const ListItemText = styled(MuiListItemText)`
  span {
    color: ${(props) => props.theme.palette.footer.color};
    font-size: 0.8125rem;
    line-height: 1.2;
  }
`;

function Footer() {
  const { isSuperuser } = useAuth();
  return (
    <Wrapper>
      <Grid container spacing={0}>
        <Hidden mdDown>
          <Grid container item xs={12} md={6}>
            <List>
              <ListItemButton component="a" href="#">
                <ListItemText primary="Support" />
              </ListItemButton>
              <ListItemButton component="a" href="#">
                <ListItemText primary="Help Center" />
              </ListItemButton>
              {!isSuperuser && (
                <ListItemButton component={RouterLink} to="/help">
                  <ListItemText primary="Tutorials" />
                </ListItemButton>
              )}
              <ListItemButton component="a" href="#">
                <ListItemText primary="Privacy" />
              </ListItemButton>
              <ListItemButton component="a" href="#">
                <ListItemText primary="Terms of Service" />
              </ListItemButton>
            </List>
          </Grid>
        </Hidden>
        <Grid container item xs={12} md={6} justifyContent="flex-end">
          <List>
            <ListItemButton>
              <ListItemText
                primary={`© ${new Date().getFullYear()} - Podium`}
              />
            </ListItemButton>
          </List>
        </Grid>
      </Grid>
    </Wrapper>
  );
}

export default Footer;
